<div class="administration-component">
  <div *ngIf="permissionsData" class="ui-g roles-container">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 margin-align">
      <h4 class="margin-header-align text-uppercase">{{'administration.title' | translate}}</h4>
      <hr/>
    </div>

    <div class="roles-section">
      <div class="table-title">{{'administration.roles-title' | translate}}</div>
      <div class="roles-table-container">
        <p-table [value]="permissionsData" styleClass="netz-table">
          <ng-template pTemplate="header">
            <tr>
              <th>{{'administration.role' | translate}}
              </th>
              <th>{{'administration.manage-authorisation' | translate}}
              </th>
              <th>{{'administration.manage-concessions' | translate}}
              </th>
              <th>{{'administration.manage-orders' | translate}}
              </th>
              <th>{{'administration.view-orders' | translate}}
              </th>
            </tr>
          </ng-template>
          <ng-template let-item let-rowIndex="rowIndex" pTemplate="body">
            <tr>
              <td>{{'administration.' + item.role | translate}}</td>
              <td class="text-center">
                <p-checkbox [disabled]="!canChangePermissions"
                            [ngModel]="item.canManageAuth"
                            [value]="item.canManageAuth"
                            binary="true"
                            class="internal-consumption-field checkbox-field"
                            id="manage-authorisations-{{rowIndex}}"></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox [disabled]="!canChangePermissions"
                            [ngModel]="item.canManageConcessions"
                            [value]="item.canManageConcessions"
                            binary="true"
                            class="internal-consumption-field checkbox-field"
                            id="manage-concessions-{{rowIndex}}"></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox [disabled]="!canChangePermissions"
                            [ngModel]="item.canManageOrders"
                            [value]="item.canManageOrders"
                            binary="true"
                            class="internal-consumption-field checkbox-field"
                            id="manage-orders-{{rowIndex}}"></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox [disabled]="!canChangePermissions"
                            [ngModel]="item.canViewOrders"
                            [value]="item.canViewOrders"
                            binary="true"
                            class="internal-consumption-field checkbox-field"
                            id="view-orders-{{rowIndex}}"></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <div *ngIf="adminData" class="ui-g permissions-section">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 margin-align">
      <h4 class="margin-header-align text-uppercase">{{'administration.permissions-title' | translate}}</h4>
      <hr/>
    </div>

    <form [formGroup]="adminFG" class="ui-g-12">
      <div class="ui-g-12 add-admin-section">
        <div class="form-row">
          <div class="ui-g-12 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 form-row">
            <label class="ui-g-3 field-label text-right-align field-label required"
                   for="admin-email">{{'administration.email' | translate}}</label>
            <input class="ui-input pInputText field-width" formControlName="email" id="admin-email"
                   maxlength="200"
                   pInputText size="30" type="text">
          </div>
          <div class="ui-g-12 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 form-row">
            <label class="ui-g-3 field-label text-right-align field-label required"
                   for="admin-firstname">{{'administration.firstname' | translate}}</label>
            <input class="ui-input pInputText field-width" formControlName="firstName" id="admin-firstname"
                   maxlength="20"
                   pInputText size="30" type="text">
          </div>
          <div class="ui-g-12 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 form-row">
            <label class="ui-g-3 field-label text-right-align field-label required"
                   for="admin-lastname">{{'administration.lastname' | translate}}</label>
            <input class="ui-input pInputText field-width" formControlName="lastName" id="admin-lastname"
                   maxlength="20"
                   pInputText size="30" type="text">
          </div>
        </div>
        <div class="form-row">
          <div class="ui-g-12 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 form-row">
            <label class="ui-g-3 field-label text-right-align field-label required"
                   for="admin-password">{{'administration.password' | translate}}</label>
            <input [feedback]="false" [showPassword]="showPassword" class="ui-input pInputText field-width"
                   formControlName="password" id="admin-password"
                   maxlength="20" pPassword size="30" type="password">
            <span class="show-password-container">
				            <i (click)="showPassword = !showPassword"
                       [ngClass]="showPassword ? 'pi pi-eye-slash': 'pi pi-eye'"></i>
				        </span>
          </div>
          <div class="ui-g-12 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 form-row">
            <label class="ui-g-3"></label>
            <p-dropdown [options]="roleTypes"
                        formControlName="role"
                        id="admin-role"
                        placeholder="{{'administration.role' | translate}}"
                        styleClass="netz-small-dropdown">
              <ng-template let-item pTemplate="selectedItem">
                <span
                  class="drop-item-label">{{'lookup.' + roleTypesKey + '.options.' + item['value'] + '.name' | translate}}</span>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="drop-item">
                  <span
                    class="drop-item-label">{{'lookup.' + roleTypesKey + '.options.' + option['value'] + '.name' | translate}}</span>
                </div>
              </ng-template>
            </p-dropdown>
            <div class="align-marker">
              <label class="required"></label>
            </div>
            <div (click)="addAdminUser()" [class.pointer-cursor]="adminFG.valid">
              <i class="pi pi-user-plus add-icon"></i>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="admin-table-container">
      <div class="overflow-tab-section">
        <div class="ui-inputgroup">
          <span class="ui-inputgroup-addon"><i class="pi pi-search search-icon"></i></span>
          <input (input)="adminTable.filterGlobal($event.target.value, 'contains')"
                 [(ngModel)]="globalFilterValue"
                 pInputText placeholder="Search"
                 size="25" type="text">
        </div>
      </div>
      <p-table #adminTable [filterDelay]="0"
               [globalFilterFields]="filterFields"
               [paginator]="true"
               [rowsPerPageOptions]="tableConfig?.rowsPerPageOptions"
               [rows]="tableConfig?.rowsPerPage"
               [scrollable]="true"
               [showCurrentPageReport]="true"
               [value]="adminData"
               currentPageReportTemplate="{{'app.paginator-current-text.showing' | translate}} {first} - {last} {{'app.paginator-current-text.of' | translate}} {totalRecords} {{'app.paginator-current-text.entries' | translate}}"
               styleClass="netz-table netz-admin-table">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name">
              {{'administration.name' | translate}}
              <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th class="email-column" pSortableColumn="email">
              {{'administration.email' | translate}}
              <p-sortIcon field="email"></p-sortIcon>
            </th>
            <th class="role-column" pSortableColumn="role">
              {{'administration.role' | translate}}
              <p-sortIcon field="role"></p-sortIcon>
            </th>
            <th class="actions-column"></th>
          </tr>
        </ng-template>
        <ng-template let-item pTemplate="body">
          <tr>
            <td>{{item.name}}</td>
            <td class="email-column">{{item['email']}}</td>
            <td class="role-column">{{'lookup.' + roleTypesKey + '.options.' + item['role'] + '.name' | translate}}</td>
            <td class="actions-column">
						<span (click)="deleteAdminUser(item['technician_id'])" *ngIf="showDeleteIcon(item)"
                  class="pointer-cursor">
								<i class="pi pi-trash"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog #deleteConfirmDialog icon="pi pi-info-circle"
                 message="{{'messages.delete-confirmation-message' | translate}}"
                 styleClass="netz-confirm-dialog">
  <p-footer>
    <button (click)="deleteConfirmDialog.accept()" label="{{'yes-button-label' | translate}}" pButton
            type="button"></button>
    <button (click)="deleteConfirmDialog.reject()" label="{{'no-button-label' | translate}}" pButton
            type="button"></button>
  </p-footer>
</p-confirmDialog>

<app-loader *ngIf="isLoading"></app-loader>
